import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_CAN_VIEW_IR,
    CLEAR_CAN_VIEW_IR_ERROR,
    LOAD_CAN_VIEW_IR_REQUEST,
    LOAD_CAN_VIEW_IR_SUCCESS,
    LOAD_CAN_VIEW_IR_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_CAN_VIEW_IR,
    CLEAR_ERROR: CLEAR_CAN_VIEW_IR_ERROR,
    LOAD_REQUEST: LOAD_CAN_VIEW_IR_REQUEST,
    LOAD_SUCCESS: LOAD_CAN_VIEW_IR_SUCCESS,
    LOAD_FAILURE: LOAD_CAN_VIEW_IR_FAILURE
}